import React, { FC } from "react";
import { ActionsGroup, TitleText, Flex } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { CloseDialogIcon } from "../../DialogComponents/CloseDialogIcon";
import { MultiEditTitle, MultiEditText } from "../styled";
import { ModeEditorToggle } from "./ModeEditorToggle";

interface FeaturesMultiEditHeaderProps {
  layerName: string;
  advancedMode: boolean;
  toggleMode: VoidFunction;
}

export const FeaturesMultiEditHeader: FC<FeaturesMultiEditHeaderProps> = ({ layerName, advancedMode, toggleMode }) => {
  const { t } = useTranslation("dialogs");

  return (
    <MultiEditTitle>
      <ActionsGroup>
        <Flex column>
          <TitleText>{t("featuresMultiEdit.setValues")}</TitleText>
          <MultiEditText>{`${t("featuresMultiEdit.layer")} ${layerName}`}</MultiEditText>
          <ModeEditorToggle advancedMode={advancedMode} toggleMode={toggleMode} />
        </Flex>
      </ActionsGroup>
      <ActionsGroup>
        <CloseDialogIcon />
      </ActionsGroup>
    </MultiEditTitle>
  );
};
